
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 13.084l.077.004a.75.75 0 010 1.492l-.077.004H1a.75.75 0 010-1.5h14zM1.75 10.75h12.5V2.917H1.75v7.833zm4.73-6.912a.75.75 0 01.769.038l3.5 2.334a.75.75 0 010 1.248l-3.5 2.333a.75.75 0 01-1.166-.624V4.5a.75.75 0 01.396-.662zm1.103 3.927l1.397-.932L7.583 5.9v1.864zm8.167 3.152c0 .736-.597 1.332-1.333 1.333H1.583A1.333 1.333 0 01.25 10.917V2.75c0-.736.597-1.333 1.333-1.333h12.834c.736 0 1.333.597 1.333 1.333v8.167z","fill":"#4A4A4A"}})])
          )
        }
      }
    